import { render, staticRenderFns } from "./invoiceShow.vue?vue&type=template&id=70bc7bae"
import script from "./invoiceShow.vue?vue&type=script&lang=js"
export * from "./invoiceShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports